class ReadMoreDescription extends HTMLElement {
  constructor () {
    super()

    this.els = {
      content: this.querySelector('[data-read-more-description-el="content"]'),
      trigger: this.querySelector('[data-read-more-description-el="trigger"]'),
    }

    this.setInitialHeight()

    this.setupListeners()
  }

  setupListeners () {
    this.els.trigger.addEventListener(
      'click',
      this.handleClick.bind(this),
    )
  }

  handleClick (event) {
    event.preventDefault()

    if (this.isExpanded) {
      this.els.content.setAttribute('aria-expanded', 'false')
      this.els.trigger.textContent = this.dataset.readMoreTranslationReadMore
    } else {
      this.els.content.setAttribute('aria-expanded', 'true')
      this.els.trigger.textContent = this.dataset.readMoreTranslationReadLess
    }
  }

  setInitialHeight () {
    const contentStyle = getComputedStyle(this.els.content)

    let lineHeight = parseFloat(contentStyle.lineHeight)

    let marginBottom = 0
    const listItems = this.els.content.querySelectorAll('li')

    listItems.forEach((li, index) => {
      if (index < 3) {
        lineHeight = parseFloat(getComputedStyle(li).lineHeight)
        marginBottom += parseFloat(getComputedStyle(li).marginBottom)
      }
    })

    this.initialHeight = lineHeight * 3.75 + marginBottom
    if (!this.isExpanded) {
      this.els.content.style.setProperty(
        '--cutoff',
        `${this.initialHeight}px`,
      )
    }
  }

  get isExpanded () {
    return this.els.content.getAttribute('aria-expanded') === 'true'
  }
}

if (!customElements.get('read-more-description')) {
  customElements.define('read-more-description', ReadMoreDescription)
}
